import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as classes from './CartButton.module.css';
import CartIcon from '../../assets/icons/inline/basket.svg';
import CartIconBlack from '../../assets/icons/inline/basketBlack.svg';
import { useCheckout } from '../../context/shopContext';

const CartButton = ({
  mobile = false,
  cartDrawerOpen,
  setCartDrawerOpen,
  burgerMenuOpen,
  setBurgerMenuOpen,
}) => {
  const icon = mobile ? CartIconBlack : CartIcon;
  const [cartCount, setCartCount] = useState(0);
  const checkout = useCheckout();

  useEffect(() => {
    if (checkout) {
      setCartCount(checkout.lineItems.length);
    }
  }, [checkout]);

  const handleClick = () => {
    setCartDrawerOpen(!cartDrawerOpen);
    if (mobile && burgerMenuOpen) {
      setBurgerMenuOpen(false);
    }
  };

  return (
    <button
      className={`${classes.cartButton} ${
        mobile ? classes.mobileCartButton : ''
      }`}
      onClick={() => handleClick()}
    >
      <div
        className={`${classes.count} ${!cartCount ? classes.countHide : ''} `}
      >
        <p>{cartCount}</p>
      </div>
      <img src={icon} alt="cart icon" />
    </button>
  );
};

CartButton.propTypes = {
  cartDrawerOpen: PropTypes.bool.isRequired,
  setCartDrawerOpen: PropTypes.func.isRequired,
};

export default CartButton;
